import {
  Box,
  Paper,
  Divider,
  List,
  ListItem,
  Typography,
  styled,
} from "@mui/material"

import Button from "components/ui/Button"
import { colors } from "theme"

export const Btn = styled(Button)(() => ({
  borderRadius: "21px",
  fontSize: "0.875rem",
  textTransform: "inherit",
  height: "44px",
  padding: "0 20px",
  width: "100%",
}))

// collapsed

export const CollapsedAside = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  flexGrow: 1,
  justifyContent: "space-between",
  margin: 0,
  padding: 0,
  width: "50%",
}))

export const Balance = styled(Typography)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  [theme.breakpoints.down("md")]: {
    fontSize: "0.85rem",
  },
}))

export const CollapsedActions = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  flexGrow: 1,
  justifyContent: "flex-end",
  margin: 0,
  padding: 0,
  width: "40%",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}))

export const CollapsedBtn = styled(Btn)(() => ({
  fontSize: "0.75rem",
  height: "36px",
  margin: "0 5px",
  width: "160px",
  padding: "0 10px",
}))

export const CollapsedLightButton = styled(CollapsedBtn)(({ theme }) => ({
  background: colors.lightPersianGreen,
  color: theme.palette.primary.main,
  fontSize: "0.75rem",
}))

export const CollapsedPrimaryButton = styled(CollapsedBtn)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.common.white,
  fontSize: "0.75rem",
}))

export const CollapsedRedButton = styled(CollapsedBtn)(() => ({
  background: colors.ruby,
  color: colors.white,
  fontSize: "0.75rem",
}))

// expanded

export const Card = styled(Paper)(({ theme }) => ({
  boxShadow: "12px 14px 23px -2px rgb(0 0 0 / 3%)",
  borderRadius: "26px",
  marginBottom: "16px",
  padding: "58px",
  [theme.breakpoints.down("md")]: {
    padding: "16px",
  },
}))

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "space-between",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column-reverse",
  },
}))

export const Aside = styled(Box)(({ theme }) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.up("md")]: {
    marginRight: "58px",
  },
  [theme.breakpoints.down("md")]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    alignSelf: "center",
    margin: "16px 0 32px",
  },
}))

export const Content = styled(Box)(() => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
}))

export const Info = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
}))

export const Line = styled(Divider)(({ theme }) => ({
  borderColor: colors.cultured,
  margin: "10px 0",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    margin: "0",
  },
}))

export const Actions = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "16px",
}))

export const ActionList = styled(List)(() => ({
  display: "flex",
  flexWrap: "wrap",
  margin: "14px 0 0 0",
  padding: "0",
  width: "100%",
}))

export const ActionListItem = styled(ListItem)(({ theme }) => ({
  padding: "0",
  margin: "8px 0",
  [theme.breakpoints.down("md")]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "4px 0",
  },
}))

export const LightButton = styled(Btn)(({ theme }) => ({
  background: colors.lightPersianGreen,
  color: theme.palette.primary.main,
}))

export const PrimaryButton = styled(Btn)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.common.white,
}))

export const InfoButton = styled(Btn)(({ theme }) => ({
  background: theme.palette.info.main,
  color: theme.palette.common.white,
}))

export const RedButton = styled(Btn)(() => ({
  background: colors.ruby,
  color: colors.white,
}))
